import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [webuser, setWebuser] = useState({WEB_USER_ID:null});
const [vchr, setVchr] = useState({numbers:'', amts:''});
const [dowait, setDowait] = useState({on:false});

const [dlwait, setDlwait] = useState({show:false});
const [modal, setModal] = useState({open:false});
const [idtype, setIdtype] = useState([
<option key='lsta1' value=''></option>
,<option key='lsta2' value='TCI Belonger Card'>TCI Belonger Status</option>
,<option key='lsta3' value='Passport'>Passport</option>
,<option key='lsta4' value='Driver License'>Driver License</option>
,<option key='lsta5' value='NIB or NHIB Card'>NIB or NHIB Card</option>
,<option key='lsta6' value='Other Id'>Other Id</option>
]);

const location = useLocation();


useEffect(() => {

let WEB_USER_ID=null;
if (location.state)
	if (location.state.WEB_USER_ID && location.state.WPT_APP_ID)
		WEB_USER_ID=location.state.WEB_USER_ID;

if (WEB_USER_ID==null)	
	showsnackbar("error: could not determine the target registration");
else
	getwebuser(WEB_USER_ID);

 },[]);




useEffect(() => {

if (document.getElementById("btnvchrs")){
	if (vchr.numbers.trim()=="" || vchr.amts.trim()==""){
		if (!document.getElementById("btnvchrs").classList.contains("hidden"))
			document.getElementById("btnvchrs").classList.add("hidden");
		}
		else if (document.getElementById("btnvchrs").classList.contains("hidden"))
			document.getElementById("btnvchrs").classList.remove("hidden");
	
	}//end if

	

 },[vchr]);







async function addvchrnumbers(e){
	e.preventDefault();
	const params={
		username: sessionStorage.getItem("USERNAME")
		, WPT_APP_ID:location.state.WPT_APP_ID
		, vchr: vchr
		
	}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/addvchrnumbers',requestOptions)
      .then(res => res.json())
      .then(res => 	afteraddvchrnumbers(res) )
      .catch(err => console.log(err));
	  
	  }//end func

function afteraddvchrnumbers(res){
	alert("Done!");
}//end func

async function getwebuser(WEB_USER_ID){

console.log('resturl: '+resturl);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WEB_USER_ID:WEB_USER_ID} )
  };		

 await fetch(resturl+'rarwpform/getwebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwebuser(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwebuser(res){
if (res.length==undefined)
	return;

let datas={};

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
setWebuser(datas);

}//end func


function vchrChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setVchr((prev) => {
return {...prev, [name]:value}
});	



}//end func

function webuserChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setWebuser((prev) => {
return {...prev, [name]:value}
});	
}//end func

async function verifywebuser(e){
	
e.preventDefault();
//console.log('resturl: '+resturl);

const confirmed=window.confirm("verify this user's registration?");

if (!confirmed)
	return;


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WEB_USER_ID:webuser.WEB_USER_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

  await fetch(resturl+'rarwpform/verifywebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	afterverifywebuser(res) )
      .catch(err => console.log(err));	
	
}//end func


async function openScans (e) {
e.preventDefault();


const params={
	WEB_USER_ID: webuser.WEB_USER_ID
	, WEB_USER_FOLDER: webuser.WEB_USER_FOLDER
	};
	
console.log("openScans "+JSON.stringify( params ) )	;
	
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };


		setDlwait({show:true});
	
  await fetch(resturl+'rarscans/getwebuserfile',requestOptions)
      .then(res => afteropenScans(res))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res){
const filename="reginfo.pdf";
//const downloadFilename = wptapp.REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	

setDlwait({show:false});


}//end func


function afterverifywebuser(res){

let VERIFY_DATE=null;
if (res.length)
	if (res.length==1)
		VERIFY_DATE=res[0].VERIFY_DATE;

if (VERIFY_DATE==null)
	showsnackbar("that failed!  try again or contact admin");
else{
	showsnackbar("done!");
	getwebuser(location.state.WEB_USER_ID);
	}
	

	
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



async function refusewebuser(e){
e.preventDefault(); 

const confirmed=window.confirm("refuse this user's registration?");

if (!confirmed)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WEB_USER_ID:webuser.WEB_USER_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

  await fetch(resturl+'rarwpform/refusewebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	afterrefusewebuser(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterrefusewebuser(res){
	
let REFUSE_COUNT=0;
if (res.length)
	if (res.length==1)
		REFUSE_COUNT=res[0].REFUSE_COUNT;

if (REFUSE_COUNT==0)
	showsnackbar("that failed!  try again or contact admin");
else{
	showsnackbar("done!");
	getwebuser(location.state.WEB_USER_ID);
	}
	
}//end func

function clickReturn(e){
	e.preventDefault(); 
	let path="wptform";
	
		if (location.state)
			if (location.state.returnpg)
				path=location.state.returnpg.path;
		
		
		console.log("nav to path: "+path);
		navigate("/"+path, {state:{WPT_APP_ID:location.state.WPT_APP_ID} })
		

}//end func
	
const AD_USER=sessionStorage.getItem("AD_USER")	;
const PROCESS_AREA=location.state.PROCESS_AREA??"";

	
  return (
    <>
	
<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
<p>
view the Id document uploaded to confirm the document is valid and the registered name is correct.
<br/>
	<span  style={{color:"brown"}} >
	If you refuse this registration, the WP application will be removed from the list of WP applications.
	</span>
<br/>
If you verify this registration, you can then contirnue to process the WP application.

</p>
<table align='center' border='0' >
			<tbody>
			<tr>
			<td align='right' >Photo Path: </td>
			<td align='left' ><input name='PHOTO_PATH' defaultValue={webuser.PHOTO_PATH} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  /></td>
			<td rowSpan="10" >
			<img src={resturl+"rarwpform/getwebuserfoto?path="+webuser.PHOTO_PATH} border='0' height="280" />
			</td>
			</tr>
			<tr>
			<td align='right' >Date: </td>
			<td align='left' ><input name='TC_STAMP' defaultValue={webuser.TC_STAMP} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  /></td>
			</tr>
			{/*
			<tr>
			<td align='right' >&nbsp; </td>
			<td align='left' >
				
				{dlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!dlwait.show && <a href="#" className="nodecor" onClick={(e)=>{openScans(e);}} ><img src="img/pdf.gif" border="0" /> Identification document</a> }
				
			</td>
			</tr>			
			*/}
			<tr>
			<td align='right' >Email: </td>
			<td align='left' ><input name='EMAIL' defaultValue={webuser.EMAIL} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  />			</td>
			</tr>
			<tr>
			<td align='right' >Full Name: </td>
			<td align='left' ><input name='FULLNAME' defaultValue={webuser.FULLNAME}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro" autoComplete='off' placeholder='full name' /></td>
			</tr>
			<tr>
			<td align='right' >Agency: </td>
			<td align='left' ><input name='AGENCY' defaultValue={webuser.AGENCY}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro" autoComplete='off' placeholder='' /></td>
			</tr>
			<tr>
			<td align='right' >Phone: </td>
			<td align='left' ><input name='PHONE' defaultValue={webuser.PHONE} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro" autoComplete='off' placeholder='phone'   /></td>
			</tr>
			<tr>
			<td align='right' >Status: </td>
			<td align='left' ><input name='STATUS' defaultValue={webuser.STATUS} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro" autoComplete='off'    /></td>
			</tr>
			<tr>
			<td align='right' >Status Date: </td>
			<td align='left' ><input name='STATUS_DATE' defaultValue={webuser.STATUS_DATE} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro" autoComplete='off'    /></td>
			</tr>
			{
				sessionStorage.getItem("USERNAME")=="ajones" &&
				<tr>
				<td align='right' ><a href="#" id='btnvchrs' className="hidden" onClick={(e)=>{addvchrnumbers(e);}} >add Vouchers</a>: </td>
				<td align='left' >
					<input name='numbers' defaultValue={vchr.numbers} onChange={(e)=>{vchrChange(e);}} autoComplete='off'    />
					<br/><input name='amts' defaultValue={vchr.amts} onChange={(e)=>{vchrChange(e);}} autoComplete='off'    />
					</td>
				</tr>
			}
		

			<tr>
			<td align='right' >&nbsp;</td>
			</tr>
			
			<tr>
			<td align='right' >
			<a href="#" className="nodecor" onClick={(e)=>{clickReturn(e);}} ><img src="img/return.png" border="0" height="20" /> return to WP application</a>
			</td>
			{webuser.STATUS_DATE=="" && AD_USER!="" && 
				<td align='left' >
				{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
				{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{verifywebuser(e);}} >verify this registration</button>}
				</td>
			}
			</tr>		
			{webuser.STATUS_DATE=="" && AD_USER!="" && 
				<tr>
				<td align='right' >&nbsp;</td>
				<td align='left' >
					<a href="#" className="nodecor" onClick={(e)=>{refusewebuser(e);}} ><img src="img/refuseapp.png" border="0" height="20" /> refuse this registration</a>
				</td>
				</tr>
			}
			</tbody>
			</table>
			
		</div>

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;